import { Button, DialogContent } from '@material-ui/core';
import AssignmentIcon from '@material-ui/icons/Assignment';
import { useSimpleModalToggle } from 'components/dialogs/useSimpleModal';
import { useGridUserDataGlobalFiltersContext } from 'contexts/GridUserDataGlobalFiltersProvider';
import React from 'react';
import { FormWithRedirect, useMutation, useNotify, useRefresh, useTranslate } from 'react-admin';
import { useNotifyError } from 'utils/notifiers/useNotifyError';

import { useTerminalContext } from '../contexts/TerminalContext';
import { useStoragePlaceAssigner } from '../hooks/useStoragePlaceAssigner';
import { useConfigFileLoader } from '../hooks/useConfigFileLoader';
import { configApi } from '../services/configApi';
import type { Place } from '../types/warehouse.types';
import { ActionDialog } from './ActionDialog';
import { AssignCompanyProductForm } from './AssignCompanyProductForm';
import { DialogConfirmActions } from './DialogConfirmActions';

interface AssignCompanyProductProps {
  selectedPlaces: Place[];
}

export const AssignCompanyProduct: React.FC<AssignCompanyProductProps> = ({selectedPlaces}) => {
  const translate = useTranslate();
  const notify = useNotify();
  const notifyError = useNotifyError();
  const { assignStoragePlaces } = useStoragePlaceAssigner();
  const { loadConfigFromBackend } = useConfigFileLoader();
  const { data: globalTerminalId  } = useGridUserDataGlobalFiltersContext();
  const [loading, setLoading] = React.useState(false);
  const { open, handleOpen, handleClose } = useSimpleModalToggle();
  
  const handleSubmit = async (values) => {
    try {
      await assignStoragePlaces({
        ...values,
        storage_place_ids: selectedPlaces.map(p => p.id),
      });
      notify('osfc.storage_ui.assign.success', 'success');
      handleClose();
      const terminalId = globalTerminalId?.terminal_id?.[0];
      // TODO - TEMPORARY SOLUTION, need partially updation
      if (terminalId) {
        await loadConfigFromBackend(terminalId);
      }
    } catch (error) {
      notifyError(error);
    }
  };

  return (
    <>
      <div style={{ marginBottom: '16px' }}>
        <Button
          size="small"
          color="primary"
          variant="contained"
          startIcon={<AssignmentIcon />}
          onClick={handleOpen}
        >
          {translate('osfc.storage_ui.assign.button')}
        </Button>
      </div>

      <ActionDialog open={open} loading={loading} title={translate('osfc.storage_ui.assign.title')}>
        <FormWithRedirect
          record={{}}
          submitOnEnter={false}
          component={DialogContent}
          save={handleSubmit}
          render={({ handleSubmitWithRedirect }) => (
            <>
              <AssignCompanyProductForm disabled={loading} />

              <DialogConfirmActions
                loading={loading}
                confirmLabel={translate('osfc.storage_ui.assign.save')}
                onCancel={handleClose}
                onConfirm={() => handleSubmitWithRedirect()}
              />
            </>
          )}
        />
      </ActionDialog>
    </>
  );
};
